import { render, staticRenderFns } from "./changsuoAdd.vue?vue&type=template&id=2c3db688"
import script from "./changsuoAdd.vue?vue&type=script&lang=js"
export * from "./changsuoAdd.vue?vue&type=script&lang=js"
import style0 from "./changsuoAdd.vue?vue&type=style&index=0&id=2c3db688&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports